<script setup lang="ts">
import IconMaterialSymbolsLockOutline from '~icons/material-symbols/lock-outline'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Button from '@/shared/components/Button.vue'
import ModuleAccessDenied from '@/app/components/access/ModuleAccessDenied.vue'

const route = useRoute()
const router = useRouter()

const moduleParam = computed(() => {
  const value = route.query.module
  if (Array.isArray(value)) return value[0] ?? null
  return value ?? null
})

const goToProjects = () => {
  router.push({ name: '/(with-statusbar)/projects/' })
}

definePage({
  meta: {
    label: 'No module access',
    icon: IconMaterialSymbolsLockOutline
  }
})
</script>

<template>
  <div class="flex w-full justify-center p-8">
    <div class="bg-card w-full max-w-xl rounded shadow">
      <ModuleAccessDenied :module="moduleParam" />
      <div class="flex justify-center p-6 pt-0">
        <Button @click="goToProjects">
          Back to projects
        </Button>
      </div>
    </div>
  </div>
</template>
